import { useQuery } from '../useQuery'
import { interactionModelOperations } from '../../interaction/redux'
import { useEffect } from 'react'
import { useAppDispatch } from 'state/store'

export const useWorkflow = async () => {
  const query = useQuery()
  const workflowUuid = query.get('uuid_workflow')
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(interactionModelOperations.setWorkflow(workflowUuid || null))
  }, [dispatch, workflowUuid])
}

export default useWorkflow
